// libraries.
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// slices.
import { apiDocumentsPortal } from '@store/apiSlices/apiSlices';

// interfaces.
import { ModelError } from '@store/apiSlices/interfaces/interfaces';

export interface SuggestionFeedbackItem {
  country: string; // MX | CO
  nid: string;
  field: string;
  fieldId: number;
  suggestionId: number | null;
  finalValue: string | number;
  selectedModel: string | null;
  finalConfidence: number;
  feedbackType: 'accept_suggestion' | 'change_suggestion' | 'manual_edit';
  agentEmail: string;
  agentComment?: string;
}

export interface SuggestionsFeedbackRequest {
  suggestions_feedback: SuggestionFeedbackItem[];
}

export interface SuggestionsFeedbackResponse {
  success: boolean;
  message?: string;
}

export const suggestionsFeedback = apiDocumentsPortal.injectEndpoints({
  endpoints: builder => ({
    postSuggestionsFeedback: builder.mutation<
      SuggestionsFeedbackResponse,
      { country: string; nid: string; body: SuggestionsFeedbackRequest }
    >({
      query: ({ country, nid, body }) => ({
        url: `/suggestions/feedback?country=${country}&nid=${nid}`,
        method: 'POST',
        body,
      }),
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'postSuggestionsFeedback',
        };
        return modelError;
      },
      transformResponse: (response: SuggestionsFeedbackResponse) => response,
    }),
  }),
});

export const { usePostSuggestionsFeedbackMutation } = suggestionsFeedback;
